import React, { useState } from 'react'
import axios from 'axios'
import { Button, Table, Glyphicon } from 'react-bootstrap'
import swal from 'sweetalert2'

import AddMapViewerBox from './AddMapViewerBox'
import MapViewerRow from './MapViewerRow'
import useSWR from '../../../hooks/useSWR'
import { swalError } from '../../../common/components/Swaler'

const defaultSortDirection = -1

const refreshInterval = 1000 * 60 * 30

const MapViewers = () => {
  const { data, mutate } = useSWR('/subject/carrier/vendors', { refreshInterval })

  const [showAddMapViewerBox, setShowAddMapViewerBox] = useState(false)
  const [sortProperty, setSortProperty] = useState('')
  const [sortDirection, setSortDirection] = useState(defaultSortDirection)

  const onChangeSort = (newSortProperty) => {
    if (sortProperty === newSortProperty) {
      setSortDirection(sortDirection * -1)
    } else {
      setSortProperty(newSortProperty)
      setSortDirection(defaultSortDirection)
    }
  }

  const sortedData = data
    ? [...data].sort((a, b) => {
        if (sortProperty === 'lastActive') {
          if (!a.lastActive) return 1
          if (!b.lastActive) return -1

          if (new Date(a.lastActive).getTime() < new Date(b.lastActive).getTime()) return sortDirection
          if (new Date(a.lastActive).getTime() > new Date(b.lastActive).getTime()) return sortDirection * -1
        }

        if (sortProperty === 'organization') {
          if (!a.organization) return 1
          if (!b.organization) return -1
        }

        const aProp = (a[sortProperty] || '').toLowerCase()
        const bProp = (b[sortProperty] || '').toLowerCase()
        if (aProp < bProp) {
          return sortDirection
        }
        if (aProp > bProp) {
          return sortDirection * -1
        }
        return 0
      })
    : []

  const addMapViewer = (formData) =>
    axios
      .post(`${window.MYQLOCX_API}/subject/carrier/vendors`, formData)
      .then((r) => {
        mutate([...data, r.data], false)
        setShowAddMapViewerBox(false)
      })
      .catch((e) => {
        if (e.response && e.response.data && e.response.data.message) swalError('Ajdå', 'Användarinfo existerar redan')
      })

  const updateMapViewer = (formData) =>
    axios
      .put(`${window.MYQLOCX_API}/subject/carrier/vendors/${formData._id}`, formData)
      .then((r) => {
        swal.fire({
          type: 'success',
          html: `<strong>${formData.email}</strong> uppdaterad`,
          timer: 1500,
          showConfirmButton: false,
        })

        const idx = data.findIndex((d) => d._id === formData._id)

        mutate([...data.slice(0, idx), { ...data[idx], ...r.data }, ...data.slice(idx + 1)], false)
      })
      .catch((e) => {
        if (e.response && e.response.data && e.response.data.message) swalError('Ajdå', 'Användarinfo existerar redan')
      })

  const removeMapViewer = async (id, email, closeModal) => {
    try {
      const { value } = await swal.fire({
        title: `Är du säkert på att du vill ta bort ${email}?`,
        type: 'warning',
        showCancelButton: true,
        confirmButtonColor: '#006e78',
        cancelButtonColor: '#CE4547',
        confirmButtonText: 'Ja',
        cancelButtonText: 'Nej!',
      })

      if (!value) return

      await axios.delete(`${window.MYQLOCX_API}/subject/carrier/vendors/${id}`)

      mutate(data.filter((d) => d._id !== id), false)

      closeModal()
      swal.fire({
        html: `Tillgång <strong>${email}</strong> raderad`,
        type: 'success',
        timer: 1500,
        showConfirmButton: false,
      })
    } catch (e) {
      console.log(e)
    }
  }

  return (
    <div>
      <Button onClick={() => setShowAddMapViewerBox(!showAddMapViewerBox)} className="add-lock-btn" bsSize="small" block>
        <Glyphicon glyph="glyphicon glyphicon-plus" /> &nbsp; Lägg till ny tillgång till karta och leveranser
      </Button>
      {showAddMapViewerBox && <AddMapViewerBox addMapViewer={addMapViewer} />}

      <h3 style={{ marginTop: 40 }} className="sub-title">
        Kart-och leveranstillgångar
      </h3>

      <Table responsive style={{ backgroundColor: 'white' }}>
        <thead>
          <tr>
            <th></th>
            <th onClick={() => onChangeSort('name')}>
              <div style={{ float: 'left' }}>{sortProperty === 'name' ? sortDirection < 0 ? <Glyphicon glyph="glyphicon glyphicon-arrow-up" /> : <Glyphicon glyph="glyphicon glyphicon-arrow-down" /> : <Glyphicon glyph="glyphicon glyphicon-sort" />}</div>
              Namn
            </th>
            <th>Email</th>
            <th onClick={() => onChangeSort('lastActive')}>
              <div style={{ float: 'left' }}>{sortProperty === 'lastActive' ? sortDirection < 0 ? <Glyphicon glyph="glyphicon glyphicon-arrow-up" /> : <Glyphicon glyph="glyphicon glyphicon-arrow-down" /> : <Glyphicon glyph="glyphicon glyphicon-sort" />}</div>
              Senast aktiv
            </th>
            <th>Postnummer</th>
          </tr>
        </thead>
        <tbody>
          {sortedData.map((v) => (
            <MapViewerRow key={v._id} mapViewer={v} updateMapViewer={updateMapViewer} removeMapViewer={removeMapViewer} />
          ))}
        </tbody>
      </Table>
    </div>
  )
}

export default React.memo(MapViewers)
